import { render, staticRenderFns } from "./Support.html?vue&type=template&id=7cdb41fe&scoped=true&external"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.scss?vue&type=style&index=0&id=7cdb41fe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdb41fe",
  null
  
)

export default component.exports